import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/LocaleContext';

export default function RegisterAgreementCheckbox({ checked, onChange, disabled = false }) {
  const { t } = useTranslation();

  return (
    <label className={`register-agree ${disabled ? 'register-agree--disabled' : ''}`}>
      <input
        type="checkbox"
        className="register-agree__input"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
      />
      <span className="register-agree__text">
        {t('register.agreePrefix')}{' '}
        <Link
          to="/agreement"
          className="register-agree__link"
          onClick={(event) => event.stopPropagation()}
        >
          {t('register.userAgreement')}
        </Link>
        {' '}
        {t('register.agreeConnector')}
        {' '}
        <Link
          to="/privacy-policy"
          className="register-agree__link"
          onClick={(event) => event.stopPropagation()}
        >
          {t('register.privacyPolicy')}
        </Link>
      </span>
    </label>
  );
}
